<template>
  <div class="web-logo clearfix" @click="goIndex">
    <img src="@static/images/logo.png" alt height="40px" />
    <div class="text-box">
      <div class="text1" :class="{'ios':$tools.ios}">凤栖云服</div>
      <div class="text2">开放，见未来</div>
    </div>
  </div>
</template>

<script>
export default {
  props:[],
  components: {},
  data() {
    return {
    };
  },
  watch: {},
  computed: {},
  created() {
  },
  methods: {
    goIndex: function () {
      //跳转到首页
      this.$router.push("/index_content");
    },
  },
};
</script>
<style lang="scss" scoped>
.web-logo{
  display: flex;
  justify-content: center;
  align-items: center;
  .text-box {
    // font-family: "思源黑体 CN";
    margin-left: 8px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    .text1{
      font-size: 20px;
      font-weight: bold;
      letter-spacing: 2px;
      color: #333;
      &.ios {
        letter-spacing: 6px;
      }
    }
    .text2{
      font-size: 12px;
      letter-spacing: 1px;
      color: #666;
      line-height: 1;
      margin-top: 5px;
    }
  }
  
}
</style>